import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/hooks';

import {
  subscribeToAnalyzers,
  selectConnectionStatus,
} from 'features/spectrasWebSocketServer/spectrasWebSocketServerSlice';

import { selectedWallChanged } from '../wallsSlice';
import { UserNoPassword, Window } from 'types';

interface Params {
  windows: Window[] | undefined;
  user: UserNoPassword | null;
  wallId: number;
}

const useReconnectToAnalyzers = ({ windows, user, wallId }: Params) => {
  const dispatch = useAppDispatch();
  const [needsReconnected, setNeedsReconnected] = useState<boolean>(false);
  const wsConnectionStatus = useAppSelector(selectConnectionStatus);

  useEffect(() => {
    if (!wsConnectionStatus) return;
    setNeedsReconnected(true);
  }, [wsConnectionStatus]);

  useEffect(() => {
    if (!windows || windows.length === 0 || !user?.id || !needsReconnected)
      return;
    const analyzerIds = windows.map((window) => window.analyzer_id);
    dispatch(
      subscribeToAnalyzers({
        user_id: user.id,
        analyzer_ids: analyzerIds,
      })
    );
    dispatch(selectedWallChanged(wallId));
    setNeedsReconnected(false);
  }, [dispatch, needsReconnected, wallId, windows, user?.id]);
};

export default useReconnectToAnalyzers;
